import React, { Component } from 'react';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { ImageField } from 'components/field';

import { FileInput, TextInput } from 'components/input';

import {
  DisabledInputOptions,
} from 'util/constants';

export class ShopMenuImport extends Component {

  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('menu', record['menu']);

    props.crudUpdate(props.resource, props.id,
      formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    return (
      <Edit
        {...this.props}
        handleSubmit={this.handleSubmit}
      >
        <SimpleForm>
          <TextInput options={DisabledInputOptions} source="shop_name" label="Shop Name"/>
          <FileInput source='menu' label='Menu' placeholder={<p>Select or drop your file here</p>}>
            <ImageField source="src" title="title"/>
          </FileInput>
        </SimpleForm>
      </Edit>)

  }
}



// WEBPACK FOOTER //
// ./src/routes/shop/ShopMenuImport.js